// extracted by css-extract-rspack-plugin
export default {"container":"_21c6f2d5"};